import { render } from "./AppFooter.vue?vue&type=template&id=a92da078&bindings={}"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"
script.render = render

export default script